import { OsmosysModule } from '@osmosys/types';

export const setProcessTitle = (appName: OsmosysModule | 'app') => {
  process.title = `osmosys-${appName}`;
  process.stdout.write(
    String.fromCharCode(27) + ']0;' + process.title + String.fromCharCode(7)
  );
};
